var React = require('react');

function NutritiionIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_5640","data-name":"Path 5640","d":"M7.375,9.151a4.853,4.853,0,0,0,2.459.68A4.915,4.915,0,1,0,7.375.68v0A4.856,4.856,0,0,0,4.915,0a4.915,4.915,0,0,0,0,9.83,4.853,4.853,0,0,0,2.459-.68M1.041,4.915A3.876,3.876,0,1,1,4.915,8.79,3.879,3.879,0,0,1,1.041,4.915","fill":"#383b23"}));
}

NutritiionIcon.defaultProps = {"width":"14.749","height":"9.83","viewBox":"0 0 14.749 9.83"};

module.exports = NutritiionIcon;

NutritiionIcon.default = NutritiionIcon;
